import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icons'
import styles from './BottomNav.module.scss'

/**
 * Нижняя навигационная панель для мобильных устройств.
 * Появляется только на узких экранах (max-width: 768px).
 *
 * Использование:
 *   <BottomNav items={[
 *     { key: 'home', icon: 'home', label: 'Главная', path: '/home' },
 *     { key: 'schedule', icon: 'schedule', label: 'Расписание', path: '/schedule' },
 *     { key: 'journal', icon: 'journal', label: 'Журнал', path: '/journal' },
 *     { key: 'chat', icon: 'message', label: 'Чат', path: '/chats' },
 *     { key: 'profile', icon: 'user', label: 'Профиль', path: '/personalcard' },
 *   ]} />
 */
const BottomNav = ({ items = [], hidden = false }) => {
  const { t } = useTranslation('common')
  const location = useLocation()

  const normalizePath = (path) => path.replace(/\/+$/, '') || '/'
  const currentPath = normalizePath(location.pathname)
  const isActive = (path) => {
    const normalizedPath = normalizePath(path)
    return currentPath === normalizedPath || (normalizedPath !== '/' && currentPath.startsWith(`${normalizedPath}/`))
  }
  const handleClick = (event, path) => {
    // Keep a repeated tap on the current page from adding a new history entry.
    // Modified clicks retain the link's normal new-tab/window behavior.
    if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey
      && currentPath === normalizePath(path) && !location.search && !location.hash) {
      event.preventDefault()
    }
  }

  return (
    <nav
      className={`${styles.bottomNav} ${hidden ? styles.hidden : ''}`}
      aria-label={t('auto.unvui_bottomnav.aria', 'Нижняя навигация')}
      aria-hidden={hidden || undefined}>
      {items.map((it) => (
        <Link
          key={it.key}
          to={it.path}
          className={`${styles.item} ${isActive(it.path) ? styles.active : ''}`}
          onClick={(event) => handleClick(event, it.path)}
          aria-label={it.label}
          title={it.label}
          tabIndex={hidden ? -1 : undefined}
          aria-current={isActive(it.path) ? 'page' : undefined}
        >
          <Icon
            name={it.icon}
            size={22}
            color={isActive(it.path) ? 'var(--color-accent)' : 'var(--color-text-muted)'}
          />
          <span className={styles.label}>{it.label}</span>
        </Link>
      ))}
    </nav>
  )
}

export default BottomNav
